/**
 * Calculates the total price based on tiered pricing structure
 * @param {number} quantity - The quantity of items
 * @param {Array} tiers - Array of tier objects with price, startingUnit, and endingUnit
 * @param {number} basePrice - The base price to use if no tiers are provided
 * @returns {number} - The calculated total price in pounds (not cents)
 */
export const calculateTieredPrice = (quantity, tiers = [], basePrice = 0) => {
  if (!tiers || tiers.length === 0) {
    return basePrice ? (basePrice * quantity) / 100 : 0;
  }

  let totalPrice = 0;
  const sortedTiers = [...tiers].sort((a, b) => a.startingUnit - b.startingUnit);

  for (let i = 0; i < sortedTiers.length; i++) {
    const tier = sortedTiers[i];

    if (tier.startingUnit > quantity) {
      continue;
    }

    if (
      (tier.endingUnit && quantity <= tier.endingUnit) ||
      (!tier.endingUnit && quantity >= tier.startingUnit)
    ) {
      totalPrice = (tier.price * quantity) / 100;
      break;
    }
  }

  return totalPrice;
};

/**
 * Gets the price for a single unit based on tiered pricing structure
 * @param {number} quantity - The quantity of items
 * @param {Array} tiers - Array of tier objects with price, startingUnit, and endingUnit
 * @param {number} basePrice - The base price to use if no tiers are provided
 * @returns {number} - The price for a single unit in pounds (not cents)
 */
export const getTieredSingleUnitPrice = (quantity, tiers = [], basePrice = 0) => {
  if (!tiers || tiers.length === 0) {
    return basePrice ? basePrice : 0;
  }

  let price = 0;
  const sortedTiers = [...tiers].sort((a, b) => a.startingUnit - b.startingUnit);

  for (let i = 0; i < sortedTiers.length; i++) {
    const tier = sortedTiers[i];

    if (tier.startingUnit > quantity) {
      continue;
    }

    if (
      (tier.endingUnit && quantity <= tier.endingUnit) ||
      (!tier.endingUnit && quantity >= tier.startingUnit)
    ) {
      price = tier.price / 100;
      break;
    }
  }

  return price;
};
